// extracted by mini-css-extract-plugin
export default {"main":"LinkButton_main__HTvVZ"};